import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api/auth.js';
import { ApiClientError } from '../api/client.js';
import { AuthCard } from '../ui/AuthCard.js';
import { Button } from '../ui/Button.js';
import { Field } from '../ui/Field.js';
import { t } from '../i18n/index.js';

export function ForgotPasswordPage() {
  const labels = t();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setError(null);
    setMessage(null);
    setBusy(true);

    try {
      const response = await forgotPassword({ email });
      // Le serveur repond la meme chose que l'adresse existe ou non.
      setMessage(response.message ?? labels.auth.forgot.subtitle);
    } catch (cause) {
      setError(cause instanceof ApiClientError ? cause.message : labels.errors.unexpected);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthCard
      title={labels.auth.forgot.title}
      subtitle={labels.auth.forgot.subtitle}
      footer={<Link to="/connexion">{labels.auth.forgot.backToLogin}</Link>}
    >
      <form onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="fg-alert fg-alert--error" role="alert">
            {error}
          </div>
        )}
        {message && (
          <div className="fg-alert fg-alert--success" role="status">
            {message}
          </div>
        )}

        <Field
          label={labels.auth.emailLabel}
          type="email"
          name="email"
          autoComplete="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          disabled={busy}
        />

        <div className="fg-auth__actions">
          <Button type="submit" busy={busy}>
            {labels.auth.forgot.submit}
          </Button>
        </div>
      </form>
    </AuthCard>
  );
}
